const DEV_API_BASE = 'https://api.dev.rezervator.ba/api/v1';

function hostnameOf(host?: string): string {
  const value = host || (typeof window !== 'undefined' ? window.location.hostname : '');
  return value.split(':')[0];
}

export function isDevServerHost(host?: string): boolean {
  const hostname = hostnameOf(host);
  return hostname === 'dev.rezervator.ba' || hostname.endsWith('.dev.rezervator.ba');
}

export function getApiBase(host?: string): string {
  if (isDevServerHost(host)) return DEV_API_BASE;
  return process.env.NEXT_PUBLIC_API_URI || '';
}
